import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import VueDraggable from 'vuedraggable';
import type { SortableEvent } from 'sortablejs';


export default /*#__PURE__*/_defineComponent({
  __name: 'DraggableList',
  props: {
    value: null,
    itemKey: null,
    selected: null,
    draggable: { type: Boolean, default: true },
    hideCounter: { type: Boolean, default: false }
  },
  emits: ["input", "row-click", "drag-end"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', value: Record<string, unknown>[]): void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: 'row-click', item: any, index: number): void;
    (e: 'drag-end', item: SortableEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: Record<string, any>[], itemKey: string, selected?: string | number, draggable: boolean, hideCounter: boolean };





const _model = computed({
    get: () => props.value,
    set: (value: Record<string, unknown>[]) => {
        emit('input', value);
    }
});

const isSelected = computed(() => {
    return (item: Record<string, unknown>) => {
        return item[props.itemKey] === props.selected;
    };
});

return { __sfc: true,props, emit, _model, isSelected, VueDraggable }
}

})